import { defineMessages } from 'react-intl';
import { SportTermLookup, SportTerminology } from '../../../lib/types';

export const scope = 'app.components.CreatePlayerForm';

export const getCreatePlayerMessages = (termLookup: SportTermLookup) => {
  const athlete = termLookup[SportTerminology.ATHLETE].toLowerCase();

  return defineMessages({
    lblFirstName: {
      id: `${scope}.lblFirstName`,
      defaultMessage: 'First Name'
    },
    lblLastName: {
      id: `${scope}.lblLastName`,
      defaultMessage: 'Last Name'
    },
    lblNickname: {
      id: `${scope}.lblNickname`,
      defaultMessage: 'Nickname'
    },
    lblDate: {
      id: `${scope}.lblDate`,
      defaultMessage: 'Date of Birth'
    },
    lblGender: {
      id: `${scope}.lblGender`,
      defaultMessage: 'Gender'
    },
    lblPosition: {
      id: `${scope}.lblPosition`,
      defaultMessage: 'Position'
    },
    lblAgeGroup: {
      id: `${scope}.lblAgeGroup`,
      defaultMessage: 'Age Group'
    },
    lblExternalId: {
      id: `${scope}.lblExternalId`,
      defaultMessage: 'External ID'
    },
    lblPrimarySport: {
      id: `${scope}.lblPrimarySport`,
      defaultMessage: 'Primary Sport'
    },
    btnSubmit: {
      id: `${scope}.btnSubmit`,
      defaultMessage: 'Create ' + termLookup[SportTerminology.ATHLETE],
    },
    btnSubmitting: {
      id: `${scope}.btnSubmitting`,
      defaultMessage: 'Saving...',
    },
    errNameTaken: {
      id: `${scope}.errNameTaken`,
      defaultMessage: `Another ${athlete} named {name} already exists in this association, with a date of birth of {dateOfBirth}. If this is the same ${athlete}, enter that date of birth to add them to this assessment. If this is a different ${athlete}, give one of them a nickname to tell them apart.`,
    },
    errNameTakenUnknownDob: {
      id: `${scope}.errNameTakenUnknownDob`,
      defaultMessage: `Another ${athlete} named {name} already exists in this association, with no date of birth on file. If this is a different ${athlete}, give one of them a nickname to tell them apart.`,
    },
    errSubmitFailed: {
      id: `${scope}.errSubmitFailed`,
      defaultMessage: `Couldn't create this ${athlete}. Please try again.`,
    }
  });
}
